// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './InputQuantityRound.scss';
import icons from '../../assets/styles/icons.scss';
import classNames from 'classnames/bind';

export type InputQuantityRoundAction = 'more' | 'less';

type Props = {
  +handleChange: (action: InputQuantityRoundAction) => void;
  +quantity: string;
  +className?: { [key: string]: string };
  +disableLess?: boolean;
  +disableMore?: boolean;
};

export const InputQuantityLoading = () => (
  <section className={style.quantityControl}>
    <i className={classNames(icons.iconMinusMedium, style.minus, style.disabled)}/>
    <p className={style.loadingContentCircle}/>
    <i className={classNames(icons.iconPlusMedium, style.plus, style.disabled)}/>
  </section>
);

export default class InputQuantityRound extends Component<Props, void> {
  static defaultProps = {
    className: {},
  };

  render() {
    const { quantity, handleChange, className, disableLess, disableMore } = this.props;
    return (
      <section className={classNames(style.quantityControl, className)}>
        <i className={classNames(icons.iconMinusMedium, style.minus)}
           onClick={() => !disableLess && handleChange('less')}/>
        <p>{quantity}</p>
        <i className={classNames(icons.iconPlusMedium, style.plus)}
           onClick={() => !disableMore && handleChange('more')}/>
      </section>
    );
  }
}

InputQuantityRound.propTypes = {
  handleChange: PropTypes.func.isRequired,
  quantity: PropTypes.string.isRequired,
  className: PropTypes.object,
  disableLess: PropTypes.bool,
  disableMore: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/InputQuantityRound/InputQuantityRound.jsx